import React from 'react';
import TermsConditionsEditSection from '../../../sections/AdminDashboard/Content/TermsConditionsEdit';

const TermsConditionsEdit = () => {
  return <TermsConditionsEditSection />;
};

export default TermsConditionsEdit;

